export function evaluateCondition(condition, context) {
    switch (condition.type) {
        case "answerEquals":
            return context.answers[condition.questionId] === condition.answerId;
        case "answerIn":
            return condition.answerIds.includes(context.answers[condition.questionId] ?? "");
        case "scoreAtLeast":
            return (context.scores?.[condition.category] ?? 0) >= condition.value;
        case "scoreBelow":
            return (context.scores?.[condition.category] ?? 0) < condition.value;
        case "all":
            return condition.conditions.every((child) => evaluateCondition(child, context));
        case "any":
            return condition.conditions.some((child) => evaluateCondition(child, context));
        case "not":
            return !evaluateCondition(condition.condition, context);
        default:
            return assertNever(condition);
    }
}
function assertNever(value) {
    throw new Error(`Unsupported condition: ${JSON.stringify(value)}`);
}
